(function () {
  var lavadoraOldPath = '/products/lavadora-wap-alta-pressao-portatil-com-2-baterias-48v';
  var lavadoraNewPath = '/products/lavadora-de-alta-pressao-portatil';
  var replacements = [
    ['Loja oficial', 'Loja brasileira'],
    ['Envios em até 24h para todo o Brasil', 'Envio com rastreio para todo o Brasil'],
    ['Envios em ate 24h para todo o Brasil', 'Envio com rastreio para todo o Brasil'],
    ['Lavadora de Alta Pressão Portátil 48V Sem Fio 2 Baterias Wap Hidrolavadora Carro Moto', 'Lavadora de Alta Pressão Portátil 48V Sem Fio 2 Baterias Hidrolavadora Carro Moto'],
    ['Lavadora de Alta Pressao Portatil 48V Sem Fio 2 Baterias Wap Hidrolavadora Carro Moto', 'Lavadora de Alta Pressão Portátil 48V Sem Fio 2 Baterias Hidrolavadora Carro Moto'],
    [' Wap ', ' '],
    [' WAP ', ' ']
  ];

  function cleanTextNode(node) {
    var value = node.nodeValue;
    if (!value) return;
    replacements.forEach(function (pair) {
      value = value.split(pair[0]).join(pair[1]);
    });
    value = value.replace(/Vendidos:\s*\d*/gi, '').replace(/Restam:\s*\d*/gi, '');
    node.nodeValue = value;
  }

  function walkText(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) cleanTextNode(node);
  }

  function hideRiskyMicrocopy() {
    document.querySelectorAll('span, small, p, div').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (/^(Vendidos:|Restam:)/i.test(text) || /Últimas unidades/i.test(text) || /Ultimas unidades/i.test(text)) {
        el.setAttribute('data-fb-merchant-hidden', 'true');
      }
    });
  }

  function fixLavadoraLinks() {
    document.querySelectorAll('a[href*="lavadora-wap-alta-pressao-portatil-com-2-baterias-48v"]').forEach(function (link) {
      link.href = link.href.replace(lavadoraOldPath, lavadoraNewPath);
    });
  }

  function runCleanup() {
    walkText(document.body);
    hideRiskyMicrocopy();
    fixLavadoraLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup);
  } else {
    runCleanup();
  }

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._fbTimer);
    observer._fbTimer = window.setTimeout(runCleanup, 80);
  });
  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
